import { AnnouncementProps } from "../interfaces/announcement_types"
import { API, APIResponse } from "@/components/_Shared/API/API"

export async function postAnnouncement(announcement: AnnouncementProps): Promise<APIResponse<AnnouncementProps>> {
    return API.post('api/announcements/', announcement)
}

export async function getAnnouncements(): Promise<APIResponse<AnnouncementProps[]>> {
    return API.get<AnnouncementProps[]>('api/announcements/')
}